export function resaDemandRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_RESA_DEMAND_START":           
        case "UPDATE_RESA_DEMAND_START":           
        case "DELETE_RESA_DEMAND_START":           
        case "FETCH_RESA_DEMANDS_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_RESA_DEMAND_FULFILLED":           
        case "UPDATE_RESA_DEMAND_FULFILLED":           
        case "DELETE_RESA_DEMAND_FULFILLED":           
        case "FETCH_RESA_DEMANDS_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_RESA_DEMAND_ERROR":
        case "UPDATE_RESA_DEMAND_ERROR":
        case "DELETE_RESA_DEMAND_ERROR":
        case "FETCH_RESA_DEMANDS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}